const observedElements = new WeakMap();

let sendView = null;

const observer = new IntersectionObserver(
    (entries) => {
        entries.forEach(entry => {
                const el = entry.target;

                if (entry.isIntersecting && !observedElements.get(el)?.reported) {
                    const timeoutId = setTimeout(() => {
                        if (sendView) sendView(el);
                        observedElements.set(el, {reported: true});
                        observer.unobserve(el);
                    }, 2000);

                    observedElements.set(el, {timeoutId});
                } else {
                    const data = observedElements.get(el);
                    if (data?.timeoutId) clearTimeout(data.timeoutId);
                }
            }
        );
    }, {threshold: 1.0}
);

function track(elements, callback) {
    if (callback) sendView = callback;
    elements.forEach(element => {
        if (!observedElements.has(element)) {
            observer.observe(element);
        }
    });
}

export {track};